// Canonical role-string constants, matching the backend's authority strings exactly.
export const UserRole = {
  STUDENT: "ROLE_STUDENT",
  ADMIN: "ROLE_ADMIN",
  FACULTY: "ROLE_FACULTY",
  OPERATOR: "ROLE_OPERATOR",
} as const;

export type UserRoleValue = (typeof UserRole)[keyof typeof UserRole];
